import React, { useState } from 'react';

import Button from 'lib/components/button/Button';
import DatePicker from 'lib/components/date-picker/DatePicker';
import Input from 'lib/components/input/Input';
import { normalizeDateAnswer } from 'lib/dateMeasure';

function DateAnswerInput({ answerType, value, onChange }) {
  const [isManualEntry, setIsManualEntry] = useState(false);

  const normalizeValue = () => {
    const normalized = normalizeDateAnswer(value);
    if (normalized && normalized !== value) {
      onChange(normalized);
    }
  };

  const toggleEntryMode = () => {
    normalizeValue();
    setIsManualEntry(!isManualEntry);
  };

  const inputProps = {
    label: 'Answer',
    'data-answertype': answerType,
    'data-testid': 'AnswerForm.answerInput',
    value,
  };

  return (
    <>
      {isManualEntry ? (
        <Input
          {...inputProps}
          placeholder='YYYY-MM-DD'
          onChange={(ev) => onChange(ev.target.value)}
          onBlur={normalizeValue}
        />
      ) : (
        <DatePicker {...inputProps} onChange={onChange} />
      )}
      <Button
        type='button'
        className='link-button date-entry-mode-toggle'
        data-testid='AnswerForm.dateEntryModeToggle'
        onClick={toggleEntryMode}
      >
        {isManualEntry ? 'Use the date picker' : 'Type the date manually'}
      </Button>
    </>
  );
}

export default DateAnswerInput;
